<script setup lang="ts">
import dateHelper from "@/core/helpers/dateHelper";

defineProps<{
    products: {
        name: string;
        code: string|number;
        date: string;
    }[];
}>();
</script>

<template>
  <div class="flex flex-col">
    <p v-for="sale in products.slice(0,3)" :key="sale.code">
      {{ sale.name }} - {{ sale.code }} le {{ dateHelper.mediumFormat(sale.date) }}
    </p>
    <p v-if="products.length - 3 > 0" class="text-xs">
      <v-tooltip>
        <template #activator="{ props }">
          <span v-bind="props" class="cursor-pointer">+ {{ products.length - 3 }} autres</span>
        </template>
        <template #default>
          <div class="flex flex-col">
            <p v-for="sale in products.slice(3)" :key="sale.code">
              {{ sale.name }} - ({{ sale.code }}) le {{ dateHelper.mediumFormat(sale.date) }}
            </p>
          </div>
        </template>
      </v-tooltip>
    </p>
  </div>
</template>
